import React, {useState, useEffect} from 'react';
import {TipoServiciosEmpresa} from './TipoServiciosEmpresa';
import {useSessionStore} from '../../hooks/useSessionStore';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import axios from 'axios';
import {eliminarEspaciosYCamelizar} from '../../fuctions/eliminarEspaciosYCamelizar';
import {useNavigate} from 'react-router-dom';
import {
	constraseñaErronea,
	emailErroneo,
	codigoPostalErroneo,
	telefonoErroneo,
	datosVacio,
} from '../../fuctions/validacionFormularios';
import {ViewContentRegistroEmpresa} from './ViewContentRegistroEmpresa';
import { FormularioRegistroEmpresa } from './FormularioResgistroEmpresa';
import { convertLength } from '@mui/material/styles/cssUtils';
import { use } from 'react';

export const FormularioEmpresa = (props) => {
	/* Destructuring the props object. */
	const {borrarCuenta, idEmpresa} = props;

	/* Using the useSessionStore hook to get the UsuarioContext from the session storage. */
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);

	const [ModalUbiacion, setModalUbiacion] = useState(false);
	const [SeleccionUbicacion, setSeleccionUbicacion] = useState(false);
	const [Ubicacion, setUbicacion] = useState({
		lat: 0,
		lng: 0,
	});
	const [RadioUbicacion, setRadioUbicacion] = useState(3000);

	/* Declaring a variable called ParteFormulario and setting it to 0. */
	const [ParteFormulario, setParteFormulario] = useState(0);

	/* Declaring a variable called TipoEmpresa and setting it to true. */
	const [TipoEmpresa, setTipoEmpresa] = useState(true);

	/* Creating a state variable called Files and setting it to an empty object. */
	const [Files, setFiles] = useState({});

	/* Declaring a variable called FotoPerfil and setting it to null. */
	const [FotoPerfil, setFotoPerfil] = useState(null);

	/* Declaring a variable called PoliticaPrivacidad and setting it to false. */
	const [PoliticaPrivacidad, setPoliticaPrivacidad] = useState(false);

	/* Declaring a variable called DocumentacionAcreditativa and setting it to false. */
	const [DocumentacionAcreditativa, setDocumentacionAcreditativa] = useState(false);

	/* Creating a state variable called ListaProvincias and a function to update it called
    setListaProvincias. */
	const [ListaProvincias, setListaProvincias] = useState([]);
	const [Provincia, setProvincia] = useState('-- Seleccione --');

	/* Creating a state variable called ListaLocalidades and a function to update it called
    setListaLocalidades. */
	const [ListaLocalidades, setListaLocalidades] = useState([]);
	const [Localidad, setLocalidad] = useState('-- Seleccione --');

	const [codPostalSeleccionado, setCodPostalSeleccionado] = useState();

	/* The above code is declaring a state variable called "ListaSuperCategorias" using the useState
    hook in a React component. The initial value of the state variable is an empty array. */
	const [ListaSuperCategorias, setListaSuperCategorias] = useState([]);

	/* Creating a state variable called CategoriasPosibles and a function to update it called
    setCategoriasPosibles. */
	const [CategoriasPosibles, setCategoriasPosibles] = useState([]);

	/* Creating a state variable called ServiciosPosibles and a function to update it called
    setServiciosPosibles. */
	const [ServiciosPosibles, setServiciosPosibles] = useState([]);

	/* Creating a state variable called ErroresFormulario and a function to update it called
    setErroresFormulario. */
	const [ErroresFormulario, setErroresFormulario] = useState([]);

	const [FormErrors, setFormErrors] = useState({
		emailEmpresa: '',
		constraseña: '',
		nombreEmpresa: '',
		nombreContactoEmpresa: '',
		apellidosContactoEmpresa: '',
		telefono: '',
		nombreSede: '',
		provinciaSede: '',
		localidadSede: '',
		codPostalSede: '',
		direccionSede: '',
	});

	/* Creating a state variable called ModalErrores and setting it to false. */
	const [ModalErrores, setModalErrores] = useState(false);

	const [IdsSedes, setIdsSedes] = useState({});

	const [sedesEmpresa, setSedesEmpresa] = useState([
		{
			alias: '',
			provincia: '',
			direccion: '',
			codigoPostal: '',
			localidad: '',
			localidadCod: '',
			lat: 0,
			lon: 0,
			radio: 0,
		},
	]);

	const [paquetesServicios, setPaquetesServicios] = useState([]);

	const setProvinciaSede = (provincia, pos) => {
		const s = [...sedesEmpresa];
		ListaProvincias.forEach((prov) => {
			if (prov.id === provincia) {
				s[pos]['provincia'] = prov.nombre;
				setSedesEmpresa(s);
			}
		});
		definirLocalidades(provincia);
	};

	const anadirNuevaSede = () => {
		const s = [...sedesEmpresa];
		const sede = {
			alias: '',
			provincia: '',
			direccion: '',
			codigoPostal: '',
			localidad: '',
			localidadCod: '',
			lat: 0,
			lon: 0,
			radio: 0,
		};
		s.push(sede);
		setSedesEmpresa(s);
	};

	const cambiarSedesServicio = (servicio, sede) => {
		const listAux = [...ServiciosPosibles];
		listAux.forEach((serv) => {
			if (serv.id === servicio.id) {
				if (!serv.sedes.includes(sede)) {
					//checking if array contain the id
					serv.sedes.push(sede); //adding to array because value doesnt exists
				} else {
					serv.sedes.splice(serv.sedes.indexOf(sede), 1); //deleting
				}
			}
		});
		setServiciosPosibles(listAux);
	};

	const cambiarSedesServicioNuevo = (servicio, sede) => {
		const listAux = [...ServiciosNuevos];
		listAux.forEach((serv) => {
			if (serv.id === servicio.id) {
				if (!serv.sedes.includes(sede)) {
					//checking weather array contain the id
					serv.sedes.push(sede); //adding to array because value doesnt exists
				} else {
					serv.sedes.splice(serv.sedes.indexOf(sede), 1); //deleting
				}
			}
		});
		setServiciosNuevos(listAux);
	};

	const cambiarSedesPaqueteNuevo = (paquete, sede) => {
		const listAux = [...paquetesServicios];
		listAux.forEach((paq) => {
			if (paq.id === paquete.id) {
				if (!paq.sedes.includes(sede)) {
					//checking weather array contain the id
					paq.sedes.push(sede); //adding to array because value doesnt exists
				} else {
					paq.sedes.splice(paq.sedes.indexOf(sede), 1); //deleting
				}
			}
		});
		setServiciosNuevos(listAux);
	};

	const cambiarAliasSede = (index, event) => {
		const s = [...sedesEmpresa];
		s[index]['alias'] = event;
		setSedesEmpresa(s);
	};

	const cambiarCodigoPostalSede = (index, event) => {
		const s = [...sedesEmpresa];
		s[index]['codigoPostal'] = event;
		setSedesEmpresa(s);
	};

	const cambiarDireccionSede = (index, event) => {
		const s = [...sedesEmpresa];
		s[index]['direccion'] = event;
		setSedesEmpresa(s);
	};

	const borrarSede = (index) => {
		const s = [...sedesEmpresa];
		s.splice(index, 1);
		setSedesEmpresa(s);
	};

	const setUbicacionSede = (index, lat, lon, radio) => {
		console.log('ubicacionSede ', lat + lon);
		const s = [...sedesEmpresa];
		s[index]['lat'] = lat;
		s[index]['lon'] = lon;
		s[index]['radio'] = radio;
		setSedesEmpresa(s);
	};

	const setLocalidadSede = (localidad, pos) => {
		const s = [...sedesEmpresa];

		ListaLocalidades.forEach((loc) => {
			if (loc.id.toString() === localidad.toString()) {
				s[pos]['localidad'] = loc.nombre;
				s[pos]['localidadCod'] = localidad;
				setCodPostalSeleccionado(loc.codigoPostal);
				setSedesEmpresa(s);
			}
		});
	};

	/* Setting the state of the empresa object. */
	const [empresa, setEmpresa] = useState({
		idEmpresa: idEmpresa,
		nombreEmpresa: '',
		nombreContactoEmpresa: '',
		apellidosContactoEmpresa: '',
		constraseña: '',
		repitaConstraseña: '',
		telefono: '',
		direccion: '',
		codigoPostal: '',
		webEmpresa: '--vacio--',
		emailEmpresa: '',
		tamañoEmpresa: '0',
		shareCare: false,
		descripcionEmpresa: '',
		notasEmpresa: '',
		localidad: '',
		nivelActuacion: 0,
	});

	/* Using the useNavigate hook to navigate to a different page. */
	const navigate = useNavigate();

	/* Creating a state variable called ServiciosNuevos and a function to update it called
    setServiciosNuevos. */
	const [ServiciosNuevos, setServiciosNuevos] = useState([]);

	/**
	 * It makes an API call to a server, and then sets the state of the component with the data it
	 * receives.
	 */
	const definirServicios = () => {
		axios({
			/* Making a GET request to the url http://localhost:8000/servicio/ */
			method: 'get',
			url: window.ipdirection + 'servicio/',
		}).then((response) => {
			let listaAxu = [];
			/* Mapping the response.data array and pushing the data into a new array called
            listaAxu. */
			response.data.forEach((servicio) => {
				listaAxu.push({
					id: servicio.id,
					nombre: servicio.nombre,
					key: servicio.id,
					estado: false,
					precioMin: 1,
					horasMin: 30,
					domicilio: false,
					shareCare: false,
					descripcion: '',
					categoria_id: {
						id: servicio.categoria_id.id,
						nombre: servicio.categoria_id.nombre,
					},
					sedes: [],
					horario: [
						{
							nombre: 'lunes',
							estado: true,
							periodos: [
								{
									id: 1,
									hora_inicio: '08:00',
									hora_fin: '20:00',
									solapamiento: false,
								},
							],
						},
						{
							nombre: 'martes',
							estado: true,
							periodos: [
								{
									id: 1,
									hora_inicio: '08:00',
									hora_fin: '20:00',
									solapamiento: false,
								},
							],
						},
						{
							nombre: 'miercoles',
							estado: true,
							periodos: [
								{
									id: 1,
									hora_inicio: '08:00',
									hora_fin: '20:00',
									solapamiento: false,
								},
							],
						},
						{
							nombre: 'jueves',
							estado: true,
							periodos: [
								{
									id: 1,
									hora_inicio: '08:00',
									hora_fin: '20:00',
									solapamiento: false,
								},
							],
						},
						{
							nombre: 'viernes',
							estado: true,
							periodos: [
								{
									id: 1,
									hora_inicio: '08:00',
									hora_fin: '20:00',
									solapamiento: false,
								},
							],
						},
						{
							nombre: 'sabado',
							estado: false,
							periodos: [
								{
									id: 1,
									hora_inicio: '08:00',
									hora_fin: '20:00',
									solapamiento: false,
								},
							],
						},
						{
							nombre: 'domingo',
							estado: false,
							periodos: [
								{
									id: 1,
									hora_inicio: '08:00',
									hora_fin: '20:00',
									solapamiento: false,
								},
							],
						},
					],
				});
			});
			setServiciosPosibles(listaAxu);
		});
	};

	/**
	 * It makes a GET request to the server, and then sets the state of the component with the
	 * response.
	 */
	const definirCategorias = () => {
		axios({
			method: 'get',
			url: window.ipdirection + 'categoria/',
		}).then((response) => {
			let listaAxu = [];
			/* Mapping the response data and pushing it into an array. */
			response.data.forEach((categoria) => {
				listaAxu.push({
					id: categoria.id,
					nombre: categoria.nombre,
					superCategoria: categoria.superCategoria,
					status: false,
				});
			});
			setCategoriasPosibles(listaAxu);
		});
	};
	/**
	 * It gets the data from the backend and sets the state of the list of localities
	 */
	const definirLocalidades = (id) => {
		axios({
			method: 'get',
			url: window.ipdirection + 'localidadAll/?id_prov=' + id,
		}).then((response) => {
			console.log('response.data', response.data)
			let listaAxu = [];
			/* Mapping the response data and pushing it into an array. */
			response.data.forEach((localidad) => {
				listaAxu.push({
					id: localidad.id,
					nombre: localidad.nombre,
					provincia: localidad.provincia,
					codigoPostal: localidad.codigoPostal,
				});
			});
			setListaLocalidades(listaAxu);
		});
	};

	const getLocalidades = async () => {
		await axios({
			method: 'get',
			url: window.ipdirection + 'localidadAll/',
		}).then((response) => {
			console.log('response.data', response.data)
			let listaAxu = [];
			/* Mapping the response data and pushing it into an array. */
			response.data.forEach((localidad) => {
				listaAxu.push({
					id: localidad.id,
					nombre: localidad.nombre,
					provincia: localidad.provincia,
					codigoPostal: localidad.codigoPostal,
				});
			});
			setListaLocalidades(listaAxu);
		});
	};

	useEffect(() => {
		getLocalidades();
	}, []);
	/**
	 * It gets the data from the backend and sets the state of the listaProvincias variable
	 */
	const definirProvincias = () => {
		axios({
			method: 'get',
			url: window.ipdirection + 'provinciaAll/',
		}).then((response) => {
			let listaAxu = [];
			/* Mapping the response data and pushing it into an array. */
			response.data.forEach((provincia) => {
				listaAxu.push({
					...provincia,
				});
			});
			setListaProvincias(listaAxu);
		});
	};
	const getSuperCategorias = () => {
		let listaAxu = [];
		axios({
			method: 'get',
			url: window.ipdirection + 'superCategoria/',
		}).then((response) => {
			response.data.forEach((superCategoria) => {
				listaAxu.push({...superCategoria});
			});
			setListaSuperCategorias(listaAxu);
		});
	};
	/* Calling the functions definirServicios() and definirCategorias() when the component is mounted. */
	useEffect(() => {
		/* Defining the services and categories. */
		getSuperCategorias();
		definirProvincias();
		definirServicios();
		definirCategorias();
	}, []);

	/**
	 * It sends a POST request to the server, and then it sets the state of the component.
	 */
	const login = () => {
		/* Sending a POST request to the server with the email and password. */
		axios({
			/* A POST request to the server. */
			method: 'post',
			url: window.ipdirection + 'auth/login/',
			data: {
				email: empresa.emailEmpresa,
				password: empresa.constraseña,
			},
		}).then((response) => {
			/* A function that is being called. */
			let access = response.data.access;
			let refresh = response.data.refresh;
			let usuario = {
				access: access,
				refresh: refresh,
				tipo: 'usuarioEmpresa',
			};
			getDatosEmpresa(usuario);
		});
	};

	/**
	 * It makes a GET request to the URL http://localhost:8000/prestadorServicios/ and then sets the
	 * state of the listaCategorias variable to the response.data.
	 */
	const getDatosEmpresa = (usuario) => {
		/* Making a request to the server to get the data. */
		axios({
			method: 'get',
			url: window.ipdirection + 'prestadorServicios/',
			headers: {
				Authorization: 'Bearer ' + usuario.access,
			},
		}).then((response) => {
			// Introduciomos los datos del presatador de servicios al usuario
			usuario = {...usuario, prestadorServicios: response.data[0]};
			setUsuario(usuario);
			enviarDocumentos(usuario);
		});
	};

	const actualizarSedes = (sedes) => {
		const listAux = [...ServiciosNuevos];
		listAux.forEach((serv) => {
			const list = [];
			serv.sedes.forEach((sede) => {
				list.push(sedes[sede]);
			});
			serv.sedes = list;
		});
		setServiciosNuevos(listAux);
	};

	const registrarSede = (usuario) => {
		let id_prestador = usuario.prestadorServicios.id;
		axios({
			method: 'post',
			url: window.ipdirection + 'sedePrestador_Cliente/',
			data: {
				prestadorServicios: id_prestador,
				lat: Ubicacion.lat,
				lng: Ubicacion.lng,
				radio: RadioUbicacion,
				nombreSede: 'Sede-' + usuario.prestadorServicios.nombreEmpresa,
				sedesEmpresa: sedesEmpresa,
			},
			headers: {
				Authorization: 'Bearer ' + usuario.access,
			},
		})
			.then((response) => {
				enviarServicios(usuario, response.data['sedes']);
				enviarServicioCustom(usuario, response.data['sedes']);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	/**
	 * It sends a file to the server.
	 */
	const enviarDocumento = (Usuario, nombreFichero, url, file) => {
		if (file !== undefined) {
			const formData = new FormData();
			//formData.append("documento", File);
			let name = nombreFichero + Usuario.prestadorServicios.nombreEmpresa + '.pdf';
			formData.append('documento', file, name);
			formData.append('nombre', nombreFichero + Usuario.prestadorServicios.nombreEmpresa);
			//formData.append("nombre", "Prueba");
			formData.append('usuario_id', Usuario.prestadorServicios.usuario.id);
			axios
				.post(window.ipdirection + url + '/', formData, {
					headers: {
						Authorization: 'Bearer ' + Usuario.access,
					},
				})
				.then((response) => {})
				.catch((error) => {});
		}
	};
	/**
	 * It sends the user's documents to the server
	 */
	const enviarDocumentos = (usuario) => {
		if (TipoEmpresa) {
			enviarDocumento(
				usuario,
				'Registro_Autonomos-',
				'documentosAutonomosRegistroAutonomos',
				Files.registroAutonomos
			);
			enviarDocumento(
				usuario,
				'Alta_Seguridad_Social-',
				'documentosAutonomosAltaSS',
				Files.altaSS
			);
			enviarDocumento(
				usuario,
				'Titulacion_Acreditante-',
				'documentosAutonomosTitulacion',
				Files.titulacion
			);
			enviarDocumento(
				usuario,
				'Seguro_Responsabilidad_Civil-',
				'documentosSeguroRC',
				Files.seguroRC
			);
		} else {
			enviarDocumento(usuario, 'CIF-', 'documentosSociedadesCIF', Files.Cif);
			enviarDocumento(
				usuario,
				'Registro_IAE-',
				'documentosSociedadesRegistroIAE',
				Files.certificadoIAE
			);
			enviarDocumento(
				usuario,
				'Seguro_Responsabilidad_Civil-',
				'documentosSeguroRC',
				Files.seguroRC
			);
		}
		enviarCategorias(usuario);
	};

	/**
	 * It sends a post request to the server with the user's id and the category's id for create a categoria_empresa
	 *
	 */
	const enviarCategoria = (usuario, categoria) => {
		/* Creating an object with two properties. */
		let data = {
			empresa_id: usuario.prestadorServicios.id,
			categoria_id: categoria.id,
		};
		axios({
			/* Sending a post request to the server. */
			method: 'post',
			url: window.ipdirection + 'categoriaEmpresa/',
			headers: {
				Authorization: 'Bearer ' + usuario.access,
			},
			data: data,
		})
			.then((response) => {

			})
			.catch((error) => {
				/* Pushing the error to the list of errors and then setting the modalErrores to true. */
				let listaErrores = [];
				listaErrores.push(error);
				setErroresFormulario(listaErrores);
				setModalErrores(true);
			});
	};

	/**
	 * "Mapping through an array of objects and calling a function if the status is true."</code>
	 */
	const enviarCategorias = (usuario) => {
		CategoriasPosibles.forEach((categoria) => {
			if (categoria.status) {
				enviarCategoria(usuario, categoria);
			}
		});
		registrarSede(usuario);
		if (FotoPerfil !== null) {
			console.log('FotoPerfil.fotoPerfil', FotoPerfil.fotoPerfil)
			enviarFotoPerfil(usuario);
		}
		else navigate('/miEmpresa');
	};

	/**
	 * If the state of the service is true, then send the service to the user.
	 */
	const enviarServicios = (usuario, sedes) => {
		const promesasEnvio = ServiciosPosibles.map((serv) => {
			if (serv.estado) {
				return enviarServicio(usuario, serv, sedes);
			} else {
				return Promise.resolve(); // Retorna una promesa resuelta para los servicios desactivados
			}
		});

		return Promise.all(promesasEnvio);
	};

	const enviarPaquetesSerivicios = (usuario, sedes) => {
		let id_prestador = usuario.prestadorServicios.id;
		axios({
			method: 'post',
			url: window.ipdirection + 'paqueteServicios/',
			data: {
				prestadorServicios: id_prestador,
				paquetesServicios: paquetesServicios,
				sedes: sedes,
			},
			headers: {
				Authorization: 'Bearer ' + usuario.access,
			},
		})
			.then((response) => {})
			.catch((error) => {
				console.log(error);
			});
	};

	/**
	 * This function sends custom services to a server using axios and returns a promise.
	 * @returns A Promise object is being returned.
	 */
	const enviarServicioCustom = (usuario, sedes) => {
		// Creamos un array para almacenar las promesas
		const promesas = ServiciosNuevos.map((servicioNuevo) => {
			const data = {
				nombre: servicioNuevo.nombre,
				categoria_id: servicioNuevo.categoria_id,
			};
			return axios({
				method: 'post',
				url: window.ipdirection + 'servicio/',
				headers: {
					Authorization: 'Bearer ' + usuario.access,
				},
				data: data,
			})
				.then((response) => {
					let paquetesAux = paquetesServicios;
					const id = response.data.id;
					var index = paquetesAux.serviciosNuevos.indexOf(servicioNuevo.id);
					if (index !== -1) {
						paquetesAux.serviciosNuevos[index] = id;
					}

					servicioNuevo.id = id;

					enviarServicio(usuario, servicioNuevo);
				})
				.catch((error) => {
					setErroresFormulario(['Error al crear sus servicios personalizados']);
					setModalErrores(true);
				});
		});

		enviarPaquetesSerivicios(usuario, sedes);
		// Devolvemos una promesa que se resuelve cuando todas las promesas en el array de promesas se resuelven
		return Promise.all(promesas);
	};

	/**
	 * It sends a post request to the server with the data of the service
	 */
	const enviarServicio = (usuario, servicio, idsSedes) => {
		/* Creating an object with two properties. */
		let data = {
			prestadorServicios_id: usuario.prestadorServicios.id,
			servicio_id: servicio.id,
			precioMin: servicio.precioMin,
			horasMin: servicio.horasMin,
			descripcion: servicio.descripcion,
			domicilio: servicio.domicilio,
			shareCare: servicio.shareCare,
			sedes: servicio.sedes,
			idsSedes: idsSedes,
		};
		axios({
			/* Sending a post request to the server. */
			method: 'post',
			url: window.ipdirection + 'servicioEmpresa/',
			headers: {
				Authorization: 'Bearer ' + usuario.access,
			},
			data: data,
		})
			.then((response) => {
				//   const mapearServicio = (serv, servicio_empresaId, usuario) => {
				// console.log(response.data)
				getServicios(usuario, servicio);
			})
			.catch((error) => {
				/* Pushing the error to the list of errors and then setting the modalErrores to true. */
				let listaErrores = [];
				listaErrores.push(error);
				setErroresFormulario(listaErrores);
				setModalErrores(true);
			});
	};

	/**
	 * Fetches the list of services from the backend and maps the periods for each of them
	 *
	 * @param {Object} usuario - The user object with access token
	 *
	 * @returns {void}
	 */
	const getServicios = (usuario, servicio) => {
		axios({
			method: 'get',
			url: window.ipdirection + 'servicioEmpresa/',
			headers: {
				Authorization: 'Bearer ' + usuario.access,
			},
		})
			.then((response) => {
				response.data.forEach((serv) => {
					if (serv.servicio_id.id === servicio.id) {
						mapearServicio(servicio, serv.id, usuario);
					}
				});
				//makePeriodos(response.data, usuario);
			})
			.catch((error) => {
				let listaErrores = [];
				listaErrores.push(error);
				setErroresFormulario(listaErrores);
				setModalErrores(true);
			});
	};
	/*
	 * Maps the time periods for a specific service and service company.
	 * @param { Object } serv - Service object with information about the service.
	 * @param { String } servicio_empresa - Service company name.
	 * @param { Object } usuario - User object with information about the user.
	 */
	const mapearServicio = (serv, servicio_empresaId, usuario) => {
		serv.horario.forEach((dia) => {
			let nombre = '';
			if (dia.estado) {
				nombre = dia.nombre;
				// Loop through each period in the day
				dia.periodos.forEach((per) => {
					// Create the data object with the period information
					let data = {
						hora_inicio: per.hora_inicio,
						hora_fin: per.hora_fin,
						servicio_empresa: servicio_empresaId,
						nombre: nombre,
					};
					// Send a POST request to the server to create the period
					axios({
						method: 'post',
						url: window.ipdirection + 'periodoServicioEmpresa/',
						headers: {
							Authorization: 'Bearer ' + usuario.access,
						},
						data: data,
					})
						.then((response) => {})
						.catch((error) => {
							console.log(error);
						});
				});
			}
		});
	};

	/**
	 * It takes a user object as a parameter, creates a new FormData object, appends the user's profile
	 * picture, the name of the picture, and the user's id to the FormData object, and then sends the
	 * FormData object to the server
	 *
	 * @param {Object} usuario - The user object containing the access token and user data.
	 */
	const enviarFotoPerfil = (usuario) => {
		const formData = new FormData();
		const imagenOriginal = new Image(); // Crear un objeto imagen
		imagenOriginal.src = URL.createObjectURL(FotoPerfil.fotoPerfil); // Cargar la imagen en el objeto

		// Esperar a que la imagen se cargue
		imagenOriginal.onload = () => {
			const canvas = document.createElement('canvas');
			const ctx = canvas.getContext('2d');

			// Definir la resolución deseada
			const ancho = 300; // ancho deseado
			const alto = 300; // alto deseado

			canvas.width = ancho;
			canvas.height = alto;

			// Set image scale
			let scaleFactor = Math.max(
				canvas.width / imagenOriginal.width,
				canvas.height / imagenOriginal.height
			);

			// Finding the new width and height based on the scale factor
			let newWidth = imagenOriginal.width * scaleFactor;
			let newHeight = imagenOriginal.height * scaleFactor;

			// get the top left position of the image
			// in order to center the image within the canvas
			let x = canvas.width / 2 - newWidth / 2;
			let y = canvas.height / 2 - newHeight / 2;

			ctx.drawImage(imagenOriginal, x, y, newWidth, newHeight);

			canvas.toBlob((blob) => {
				//formData.append("documento", File);
				formData.append('imagen', blob, usuario.prestadorServicios.nombreEmpresa + '.png');
				formData.append('nombre', 'FotoPerfil-' + usuario.prestadorServicios.nombreEmpresa);
				//formData.append("nombre", "Prueba");
				formData.append('usuario_id', usuario.prestadorServicios.usuario.id);

				return new Promise((resolve, reject) => {
					axios
						.post(window.ipdirection + 'imagenPerfilEmpresa/', formData, {
							headers: {
								Authorization: 'Bearer ' + usuario.access,
							},
						})
						.then((response) => {
							return navigate('/miEmpresa');
						})
						.then(() => {
							resolve();
						})
						.catch((error) => {
							setErroresFormulario(['Error al enviar la foto de perfil']);
							setModalErrores(true);
							reject(error);
						});
				});
			});
		};
	};

	const getPresatadorPorEmail = () => {
		return axios({
			method: 'get',
			url:
				window.ipdirection +
				'hayPrestadorPorEmail/?prestadorServicios=' +
				empresa.emailEmpresa,
		})
			.then((response) => {
				if (response.data.numero !== '0') {
					setModalErrores(true);
					setErroresFormulario([
						'La dirección de correo electrónico que ingresó ya se encuentra asociada con otra cuenta. Por favor, utilice una dirección de correo electrónico diferente para completar su registro',
					]);
					return false;
				} else {
					return true;
				}
			})
			.catch((error) => {
				console.log(error);
				setModalErrores(true);
				setErroresFormulario(['Error']);
				return false;
			});
	};
	/**
	 * This function checks if the input data is valid and returns true if it is, or displays error
	 * messages in a modal if it is not.
	 */
	const comprobarDatos1_otros = () => {
		console.log('Comprobar datos ', sedesEmpresa[0]['lat'] + sedesEmpresa[0]['lon']);
		let listaErrores = [];

		/* Checking if the email is valid. */
		if (!emailErroneo(empresa.emailEmpresa)) {
			listaErrores.push('El email introducido es erróneo');
			setFormErrors({
				...FormErrors,
				emailEmpresa: 'El email introducido es erróneo',
			});
		} else {
			setFormErrors({
				...FormErrors,
				emailEmpresa: '',
			});
		}
		/*
       /* *|MARKER_CURSOR|* */
		if (empresa.constraseña !== empresa.repitaConstraseña) {
			listaErrores.push('Las contraseñas no coinciden');
			setFormErrors({
				...FormErrors,
				constraseña: 'Las contraseñas no coinciden',
			});
		}
		/* Checking if the password is valid. */
		if (!constraseñaErronea(empresa.constraseña)) {
			listaErrores.push(
				'La contraseña debe tener al menos 6 caracteres, una letra mayúscula y un número.'
			);
			setFormErrors({
				...FormErrors,
				constraseña: 'La contraseña debe tener al menos 6 caracteres, una letra mayúscula y un número.',
			});
		}

		/* Checking if the phone number is valid. */
		if (!telefonoErroneo(empresa.telefono)) {
			listaErrores.push('El teléfono introducido es erróneo');
		}
		/* Checking if the value of the field is empty. */
		if (!datosVacio(empresa.nombreEmpresa)) {
			listaErrores.push('Debe introducir un valor válido en el campo prestador de servicios');
		}
		/* Checking if the value of the variable empresa.nombreContactoEmpresa is empty. */
		if (!datosVacio(empresa.nombreContactoEmpresa)) {
			listaErrores.push('Debe introducir un valor válido en el campo nombre contacto');
		}
		/* Checking if the value of the input field is empty. */
		if (!datosVacio(empresa.apellidosContactoEmpresa)) {
			listaErrores.push('Debe introducir un valor válido en el campo apellidos');
		}
		/* Checking if the value of the variable empresa.direccion is empty. */
		if (!datosVacio(sedesEmpresa[0]['direccion'])) {
			listaErrores.push('Debe introducir un valor válido en el campo dirección');
		}

		/* Checking if the postal code is correct. */
		if (!codigoPostalErroneo(sedesEmpresa[0]['codigoPostal'])) {
			listaErrores.push('El código postal introducido es erróneo');
		}

		if (!codPostalSeleccionado || !codPostalSeleccionado.includes(sedesEmpresa[0]['codigoPostal'])) {
			listaErrores.push('El código postal seleccionado no coincide con la localidad seleccionada');
		}

		if (sedesEmpresa[0]['provincia'] === '') {
			listaErrores.push('Debe seleccionar una provincia');
		}
		if (sedesEmpresa[0]['localidad'] === '') {
			listaErrores.push('Debe seleccionar una localidad');
		}
		if (sedesEmpresa[0]['lat'] === 0 || sedesEmpresa[0]['lon'] === 0) {
			listaErrores.push('Debe de seleccionar una Ubicación para su empresa');
		}
		/* Checking if the form is valid. */
		if (listaErrores.length === 0) {
			/* Creating a new user. */
			return true;
		} else {
			/* Setting the error message error form to be displayed in the modal. */
			setErroresFormulario(listaErrores);
			setModalErrores(true);
			return false;
		}
	};
	const comprobarDatos1 = () => {
		return getPresatadorPorEmail().then((resultado) => {
			if (resultado) {
				return comprobarDatos1_otros();
			} else {
				return false;
			}
		});
	};
	/**
	 * It checks if the user has uploaded the required documents
	 */
	const comprobacionDocumentos = (listaErrores) => {
		/* Checking if the image is in the correct format. */

		if (!DocumentacionAcreditativa) {
			listaErrores.push('Debe confirmar que posee la documentación acreditativa');
		}

		// if (FotoPerfil === null) {
		// 	listaErrores.push('Debe de agregar un foto de perfil');
		// } else if (FotoPerfil.fotoPerfil === undefined) {
		// 	listaErrores.push('Debe de agregar un foto de perfil');
		// } else if (
		// 	FotoPerfil.fotoPerfil.type.toString() !== 'image/jpg' &&
		// 	FotoPerfil.fotoPerfil.type.toString() !== 'image/png' &&
		// 	FotoPerfil.fotoPerfil.type.toString() !== 'image/jpeg'
		// ) {
		// 	listaErrores.push('Formato de foto de perfil no válido');
		// }

		if (FotoPerfil !== null && FotoPerfil.fotoPerfil !== undefined) {
			if (
				FotoPerfil.fotoPerfil.type.toString() !== 'image/jpg' &&
				FotoPerfil.fotoPerfil.type.toString() !== 'image/png' &&
				FotoPerfil.fotoPerfil.type.toString() !== 'image/jpeg'
			) {
				listaErrores.push('Formato de foto de perfil no válido');
			}
		}

		/*
    if (!TipoEmpresa) {
      
      if (Files.Cif === null) {
        listaErrores.push("Debe agregar el documento : CIF");
      } else if (Files.Cif === undefined) {
        listaErrores.push("Debe agregar el documento : CIF");
      } else if (Files.Cif.type.toString() !== "application/pdf") {
        listaErrores.push("El documento CIF debe de estar en formato PDF");
      }

      
      if (Files.certificadoIAE === null) {
        listaErrores.push("Debe agregar el documento : Certificado IAE");
      } else if (Files.certificadoIAE === undefined) {
        listaErrores.push("Debe agregar el documento : Certificado IAE");
      } else if (Files.certificadoIAE.type.toString() !== "application/pdf") {
        listaErrores.push(
          "El documento Certificado IAE debe de estar en formato PDF"
        );
      }

      
      if (Files.seguroRC === null) {
        listaErrores.push(
          "Debe agregar el documento : Resguardo del seguro de responsabilidad civil"
        );
      } else if (Files.seguroRC === undefined) {
        listaErrores.push(
          "Debe agregar el documento : Resguardo del seguro de responsabilidad civil"
        );
      } else if (Files.seguroRC.type.toString() !== "application/pdf") {
        listaErrores.push(
          "El documento Resguardo del seguro de responsabilidad civil debe de estar en formato PDF"
        );
      }
    } else {
      
      if (Files.registroAutonomos === null) {
        listaErrores.push("Debe agregar el documento : Registro Autonomos");
      } else if (Files.registroAutonomos === undefined) {
        listaErrores.push("Debe agregar el documento : Registro Autonomos");
      } else if (
        Files.registroAutonomos.type.toString() !== "application/pdf"
      ) {
        listaErrores.push(
          "El documento Registro Autonomos debe de estar en formato PDF"
        );
      }

      
      if (Files.altaSS === null) {
        listaErrores.push("Debe agregar el documento : Alta Seguridad Social");
      } else if (Files.altaSS === undefined) {
        listaErrores.push("Debe agregar el documento : Alta Seguridad Social");
      } else if (Files.altaSS.type.toString() !== "application/pdf") {
        listaErrores.push(
          "El documento Alta Seguridad Social debe de estar en formato PDF"
        );
      }

      
      if (Files.titulacion === null) {
        listaErrores.push("Debe agregar el documento : Tutulación acreditante");
      } else if (Files.titulacion === undefined) {
        listaErrores.push("Debe agregar el documento : Tutulación acreditante");
      } else if (Files.titulacion.type.toString() !== "application/pdf") {
        listaErrores.push(
          "El documento Titulación acreditante debe de estar en formato PDF"
        );
      }

      
      if (Files.seguroRC == null) {
        listaErrores.push(
          "Debe agregar el documento : Resguardo del seguro de responsabilidad civil"
        );
      } else if (Files.seguroRC === undefined) {
        listaErrores.push(
          "Debe agregar el documento : Resguardo del seguro de responsabilidad civil"
        );
      } else if (Files.seguroRC.type.toString() !== "application/pdf") {
        listaErrores.push(
          "El documento Resguardo del seguro de responsabilidad civil debe de estar en formato PDF"
        );
      }
    }
    */
	};
	/**
	 * It checks if the postal code, email and webEmpresa are valid. If they are valid, it returns
	 * true. If they are not valid, it returns false.
	 * </code>
	 *
	 *
	 * A:
	 *
	 * You can use <code>Array.prototype.every</code> to check if all the elements in the array are
	 * true.
	 * <code>const comprobarDatos2 = () =&gt; {
	 *   const listaErrores = [];
	 *
	 *   /* Checking if the postal code is correct.
	 *
	 *   /* Checking if the email is valid.
	 *  @returns a boolean value.
	 */
	const comprobarDatos2 = () => {
		let listaErrores = [];

		comprobacionDocumentos(listaErrores);

		/* Checking if the value of the webEmpresa is empty. */
		if (!datosVacio(empresa.webEmpresa)) {
			setEmpresa({...empresa, webEmpresa: 'www.vacio-empresa.com'});
		}
		if (empresa.tamañoEmpresa === '') {
			setEmpresa({...empresa, tamañoEmpresa: 1});
		}
		if (!datosVacio(empresa.descripcionEmpresa)) {
			listaErrores.push('Debe de añadir una descripción a su empresa');
		}

		/* Checking if the list of errors is empty. If it is empty, it will create a user. If it is not
        empty, it will set the errors in the form and set the modal errors to true. */
		if (listaErrores.length === 0) {
			/* Creating a new user. */
			return true;
		} else {
			/* Setting the error message error form to be displayed in the modal. */
			setErroresFormulario(listaErrores);
			setModalErrores(true);
			return false;
		}
	};

	/**
	 * If the length of the listaCategorias array is equal to the length of the listaAxu2 array, then
	 * return true.
	 * @returns A boolean value.
	 */
	const hayServiciosSeleccionados = (listaCategorias) => {
		/* Creating a new array from the existing array. */
		let listaAxu = [];
		/* Mapping through the array of objects and pushing the value of the key "nombre" into the
        array "listaAxu" if the key "estado" is true. */
		ServiciosPosibles.forEach((serv) => {
			if (serv.estado) {
				listaAxu.push(serv.categoria_id.nombre);
			}
		});
		/* Creating a new array, listaAxu2, and then pushing a boolean value into it. */
		let listaCategoriasServiciosSeleccionada = [];
		/* Mapping through the listaCategorias array and checking if the listaAxu array includes the
        current item in the listaCategorias array. If it does, it pushes true to the listaAxu2
        array. */
		listaCategorias.forEach((cat) => {
			if (listaAxu.includes(cat)) {
				listaCategoriasServiciosSeleccionada.push(true);
			}
		});
		return listaCategorias.length === listaCategoriasServiciosSeleccionada.length;
	};
	/**
	 * If there are categories selected, then check if there are services selected, otherwise show an
	 * error message.
	 */
	const hayCatSeleccionadas = () => {
		if (!PoliticaPrivacidad) {
			setErroresFormulario(['Debes aceptar la política de privacidad']);
			setModalErrores(true);
		} else {
			let hay = false;
			let listaCategorias = [];
			/* Checking if the status is true and if it is, it is pushing the category to the
            listaCategorias array. */
			CategoriasPosibles.forEach((cat) => {
				cat.status && (hay = true) && listaCategorias.push(cat.nombre);
			});
			/* Checking if there are categorias selected, if there are, it will create a user, if not, it
            will set the error message and open the modal. */
			let hayServiciosCustomVacios = false;
			ServiciosNuevos.forEach((servicioNuevo) => {
				if (
					servicioNuevo.nombre.trim().length === 0 ||
					servicioNuevo.descripcion.trim().length === 0
				) {
					hayServiciosCustomVacios = true;
				}
			});
			let hayServiciosPosiblesVacios = false;
			ServiciosPosibles.forEach((servicioPosible) => {
				if (servicioPosible.estado) {
					if (servicioPosible.descripcion.trim().length === 0) {
						hayServiciosPosiblesVacios = true;
					}
				}
			});
			if (!hayServiciosCustomVacios && !hayServiciosPosiblesVacios) {
				if (hay || hayServiciosCustomVacios) {
					/* Checking if there are services selected, if there are, it will create a user, if not, it
                    will set the error message and open the modal. */
					if (hayServiciosSeleccionados(listaCategorias) || ServiciosNuevos.length > 0) {
						crearUsuario(listaCategorias);
					} else {
						setErroresFormulario([
							'Debes de seleccionar al menos un servicio por categoria',
						]);
						setModalErrores(true);
					}
				} else {
					/* Setting the error message to the modal. */
					setErroresFormulario(['Debes de seleccionar al menos una categoria']);
					setModalErrores(true);
				}
			} else {
				setErroresFormulario([
					'Todos los servicios han de tener un titulo y una descripcion',
				]);
				setModalErrores(true);
			}
		}
	};

	/**
	 * It's a function that creates a JSON object and sends it to the server
	 */
	const crearUsuario = (categoriasSeleccionadas) => {
		/* Creating a JSON object. */
		let data = {
            usuario: {
                email: empresa.emailEmpresa,
                password: empresa.constraseña,
                username: empresa.emailEmpresa,
            },
            nombreEmpresa: empresa.nombreEmpresa,
			nombreContactoEmpresa: empresa.nombreContactoEmpresa,
			apellidosContactoEmpresa: empresa.apellidosContactoEmpresa,
			telefono: empresa.telefono,
			codigoPostal: empresa.codigoPostal[0],
			emailEmpresa: empresa.emailEmpresa,
			shareCare: true,
			localidad: empresa.localidad,
            webEmpresa: empresa.webEmpresa,
            tamañoEmpresa: empresa.tamañoEmpresa,
            descripcionEmpresa: empresa.descripcionEmpresa,
			notasEmpresa: empresa.notasEmpresa,
            nivelActuacion: empresa.nivelActuacion,
            direccion: '-- sin definir --',
			//categorias:empresa.categoria
        }

		axios({
			/* Sending a post request to the server. */
			method: 'post',
			url: window.ipdirection + 'prestadorServiciosCliente/',
			data: data,
		})
			.then((response) => {
				data = {...data, localidad: Localidad, categorias: categoriasSeleccionadas};
				console.log(data);
				// axios({
				// 	method: 'post',
				// 	url: window.ipdirection + 'api/enviar-datos-prestador/',
				// 	data: data
				// })
				// 	.then((response) => {
				// 		// Nos logeamos como empresa
				// 		// para meter en el usuario los datos de la empresa
				// 		console.log('Res=', response);
				// 		login();
				// 		// añadimos y enviamos las categorias que se ha selecionado
				// 	})
				login();
			})
			.catch((error) => {
				//console.log("Error=", error.response.data['error']);
				/* A catch block that is catching an error. */
				// Añadimos los errores al modal
				let listaErrores = [];
				/* Iterating through the error object and pushing the error messages into an array. */
				listaErrores.push(error.response.data['error']);
				setErroresFormulario(listaErrores);
				setModalErrores(true);
			});
	};
	/**
	 * A function that handles the change of the input.
	 */
	const handleInpuntChange = (e) => {
		let value = e.target.value;
		setEmpresa({
			...empresa,
			[e.target.name]: value,
		});
	};
	/**
	 * A function that handles the change of the input.
	 */
	const handleInpuntChangeOnlyNumbers = (e) => {
		let value = e.target.value.replace(/\D/g, '');
		setEmpresa({
			...empresa,
			[e.target.name]: value,
		});
	};
	/**
	 * The function takes an event as an argument, and then sets the state of the component to the
	 * value of the event
	 */
	const handleChangeTamañoEmpresa = (event) => {
		const min = 1;
		const max = 1000000;
		/* Setting the value of the input field to the value of the styyyate. */
		const value = Math.max(min, Math.min(max, Number(event.target.value)));
		setEmpresa({
			...empresa,
			tamañoEmpresa: value,
		});
	};

	/**
	 * A function that changes the state of the variable "shareCare" to the opposite of what it was.
	 */
	const filtroShareCare = () => {
		/* Setting the state of the empresa object. */
		setEmpresa({
			...empresa,
			shareCare: !empresa.shareCare,
		});
	};
	/**
	 * If the id of the category is the same as the id of the category that was clicked, then change
	 * the status of the category to the opposite of what it was before.
	 */
	const cambiarCategoria = (id) => {
		let listaAxu = [];
		/* Mapping through the array of objects and checking if the id of the object is equal to the id
        passed in the function. If it is, it is changing the status of the object. */
		CategoriasPosibles.forEach((categoria) => {
			categoria.id === id && (categoria.status = !categoria.status);
			listaAxu.push(categoria);
		});
		setCategoriasPosibles(listaAxu);
		console.log(sedesEmpresa);
	};

	/**
	 * It changes the province.
	 */
	const cambiarProvincia = (provincia) => {
		definirLocalidades(provincia);
		ListaProvincias.forEach((prov) => {
			if (prov.id === provincia) {
				setProvincia(prov.nombre);
			}
		});
	};

	/**
	 * It sets the localidad of the empresa object to the localidad passed in.
	 */
	const cambiarLocalidad = (localidad) => {
		setEmpresa({...empresa, localidad: localidad.toString()});
		ListaLocalidades.forEach((loc) => {
			if (loc.id.toString() === localidad.toString()) {
				setLocalidad(loc.nombre);
			}
		});
	};

	/**
	 * If the id of the service is the same as the id of the service that was clicked, then change the
	 * state of the service to the opposite of what it was before.
	 */
	const cambiarEstadoServ = (id) => {
		let listaAxu = [];
		/* Mapping through the array and checking if the id is equal to the id passed in. If it is, it
        is changing the state of the object. */
		ServiciosPosibles.map((serv) => {
			if (serv.id === id) {
				serv.estado = !serv.estado;
			}
			listaAxu.push(serv);
		});
		setServiciosPosibles(listaAxu);
	};

	return (
		// <ViewContentRegistroEmpresa
		// 	empresa={empresa}
		// 	setEmpresa={setEmpresa}
		// 	handleInpuntChange={handleInpuntChange}
		// 	handleInpuntChangeOnlyNumbers={handleInpuntChangeOnlyNumbers}
		// 	handleChangeTamañoEmpresa={handleChangeTamañoEmpresa}
		// 	filtroShareCare={filtroShareCare}
		// 	ListaSuperCategorias={ListaSuperCategorias}
		// 	CategoriasPosibles={CategoriasPosibles}
		// 	ServiciosPosibles={ServiciosPosibles}
		// 	cambiarCategoria={cambiarCategoria}
		// 	setServiciosPosibles={setServiciosPosibles}
		// 	cambiarEstadoServ={cambiarEstadoServ}
		// 	TipoServiciosEmpresa={TipoServiciosEmpresa}
		// 	comprobarDatos1={comprobarDatos1}
		// 	comprobarDatos2={comprobarDatos2}
		// 	hayCatSeleccionadas={hayCatSeleccionadas}
		// 	borrarCuenta={borrarCuenta}
		// 	ParteFormulario={ParteFormulario}
		// 	setParteFormulario={setParteFormulario}
		// 	ModalErrores={ModalErrores}
		// 	setModalErrores={setModalErrores}
		// 	ErroresFormulario={ErroresFormulario}
		// 	FormErrors={FormErrors}
		// 	setErroresFormulario={setErroresFormulario}
		// 	TipoEmpresa={TipoEmpresa}
		// 	setTipoEmpresa={setTipoEmpresa}
		// 	DocumentacionAcreditativa={DocumentacionAcreditativa}
		// 	setDocumentacionAcreditativa={setDocumentacionAcreditativa}
		// 	Files={Files}
		// 	setFiles={setFiles}
		// 	ListaProvincias={ListaProvincias}
		// 	Provincia={Provincia}
		// 	setListaProvincias={ListaProvincias}
		// 	Localidad={Localidad}
		// 	ListaLocalidades={ListaLocalidades}
		// 	setListaLocalidades={setListaLocalidades}
		// 	cambiarLocalidad={cambiarLocalidad}
		// 	cambiarProvincia={cambiarProvincia}
		// 	FotoPerfil={FotoPerfil}
		// 	setFotoPerfil={setFotoPerfil}
		// 	PoliticaPrivacidad={PoliticaPrivacidad}
		// 	setPoliticaPrivacidad={setPoliticaPrivacidad}
		// 	ServiciosNuevos={ServiciosNuevos}
		// 	setServiciosNuevos={setServiciosNuevos}
		// 	ModalUbiacion={ModalUbiacion}
		// 	setModalUbiacion={setModalUbiacion}
		// 	SeleccionUbicacion={SeleccionUbicacion}
		// 	setSeleccionUbicacion={setSeleccionUbicacion}
		// 	Ubicacion={Ubicacion}
		// 	setUbicacion={setUbicacion}
		// 	RadioUbicacion={RadioUbicacion}
		// 	setRadioUbicacion={setRadioUbicacion}
		// 	sedesEmpresa={sedesEmpresa}
		// 	setSedesEmpresa={setSedesEmpresa}
		// 	setProvinciaSede={setProvinciaSede}
		// 	setLocalidadSede={setLocalidadSede}
		// 	anadirNuevaSede={anadirNuevaSede}
		// 	borrarSede={borrarSede}
		// 	cambiarAliasSede={cambiarAliasSede}
		// 	cambiarCodigoPostalSede={cambiarCodigoPostalSede}
		// 	cambiarDireccionSede={cambiarDireccionSede}
		// 	cambiarSedesServicio={cambiarSedesServicio}
		// 	cambiarSedesServicioNuevo={cambiarSedesServicioNuevo}
		// 	setUbicacionSede={setUbicacionSede}
		// 	paquetesServicios={paquetesServicios}
		// 	setPaquetesServicios={setPaquetesServicios}
		// 	cambiarSedesPaqueteNuevo={cambiarSedesPaqueteNuevo}
		// />
		<FormularioRegistroEmpresa
			empresa={empresa}
			setEmpresa={setEmpresa}
			ListaLocalidades={ListaLocalidades}
			setLocalidadSede={setLocalidadSede}
			CategoriasPosibles={CategoriasPosibles}
			sedesEmpresa={sedesEmpresa} 
			setSedesEmpresa={setSedesEmpresa}
			crearUsuario={crearUsuario}
			handleInpuntChange={handleInpuntChange}
		/>
	);
};
